// extracted by mini-css-extract-plugin
module.exports = {"videoBlock":"VideoBlock_videoBlock__0ROEU","position_left":"VideoBlock_position_left__k0t7H","position_right":"VideoBlock_position_right__qitgo"};